import {PortfolioReserveResponse} from "../../models/PortfolioReserve";
import {Button, Dropdown, DropdownItem, Icon, RadioGroup} from "../../../components";
import PortfolioRisk from "../PortfolioRisk";
import React, {ChangeEvent, useEffect, useState} from "react";
import {AssetTotals} from "../../../Assets/models/Assets";
import {DropdownGroup, MenuDivider} from "xps-react";
import {NO_OP} from "../../../constants/common";
import {
    selectMarketStress,
    selectPortfolioReserveButtonStates,
    selectPortfolioReserveOptions,
    setPortfolioReserveButtonStates,
    setPortfolioReserveOptions
} from "../PortfolioReserveSlice";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {releaseToggleApiClient} from "../../../ReleaseToggles/ReleaseToggleApiClient";
import LoadingIndicator from "../../../pages/LoadingIndicator";
import {useAnalyticsTrackers} from "../../../utils/useAnalyticsTrackers";

type HowRiskyRowProps = {
    portfolioRiskRowActive: number | undefined | boolean,
    onClickHowRiskInfoTip: () => void,
    editPortfolioReserve: PortfolioReserveResponse,
    assets: AssetTotals
    currentPage?: string
}

export function HowRiskyRow({
                                portfolioRiskRowActive,
                                onClickHowRiskInfoTip,
                                editPortfolioReserve,
                                assets,
                                currentPage
                            }: HowRiskyRowProps) {

    const dispatch = useAppDispatch();
    const portfolioReserveOptions = useAppSelector(selectPortfolioReserveOptions);
    const buttonState = useAppSelector(selectPortfolioReserveButtonStates)
    const reserveActionMenuState = useAppSelector(selectPortfolioReserveOptions)
    const marketStressEvents = useAppSelector(selectMarketStress)
    const [enableMarketStress, setEnableMarketStress] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(true);


    let initialMarketStressOption = "Conditional Value at Risk"
    switch (reserveActionMenuState.marketStressTest) {
        case "Historical Market Events":
            initialMarketStressOption = "Historical Market Events"
            break;
    }
    const [selectedMarketStressOption, setSelectedMarketStressOption] = useState(initialMarketStressOption)
    const handleReserveOptionDropdown = (_e: ChangeEvent<HTMLInputElement>) => {
        let selectedPortfolioReserveOptions = {...portfolioReserveOptions}
        selectedPortfolioReserveOptions.showRiskImpact = !selectedPortfolioReserveOptions.showRiskImpact;

        dispatch(setPortfolioReserveOptions(selectedPortfolioReserveOptions));
    }
    const { page} = useAnalyticsTrackers();

    const handleMarketStressOptions = (_e: ChangeEvent<HTMLInputElement>) => {
        const {value} = _e.target;
        setSelectedMarketStressOption(value);

        if (value === "Conditional Value at Risk" || value === "Historical Market Events") {
            page(`${currentPage}_Clicked_${value}`);
        }
        let selectedPortfolioReserveOptions = {...reserveActionMenuState}
        switch (value) {
            case "Conditional Value at Risk":
                selectedPortfolioReserveOptions.marketStressTest = "Conditional Value at Risk"
                break;
            case "Historical Market Events":
                selectedPortfolioReserveOptions.marketStressTest = "Historical Market Events"
                break;
            default:
                selectedPortfolioReserveOptions.marketStressTest = "Conditional Value at Risk"
                break;
        }
        dispatch(setPortfolioReserveOptions(selectedPortfolioReserveOptions));

    }

    const handleHideButton = () => {
        dispatch(setPortfolioReserveButtonStates({
            ...buttonState,
            portfolioRisk: false
        }))
    };

    useEffect(() => {
        setIsLoading(true)
        releaseToggleApiClient.getLaunchDarklyFlag("enableMarketStress").then(
            (enableMarketStressResponse) => {
                setEnableMarketStress(enableMarketStressResponse);
                setIsLoading(false)
            }
        ).catch((error) => {
            console.error('Failed to retrieve MarketStress', error.message);
        });
    }, []);

    const marketStressOptions = enableMarketStress ? ["Conditional Value at Risk", "Historical Market Events"] : ["Conditional Value at Risk"]
    const disableShowImpact = selectedMarketStressOption === "Historical Market Events";

    const investableAssetsMinusCashForReserveTarget = assets.totalInvestableValue - editPortfolioReserve.reserveTargetCashValue;

    const investableAssetsMinusCashForMinimumRisk = assets.totalInvestableValue - editPortfolioReserve.minimumRiskCashValue;

    const stressEventDropdownItems = marketStressEvents.marketStressResponses
        .map((event) => {
            return (<DropdownItem key={""} className="" value={""} itemText={event.name.toString()}
                                  onClick={NO_OP}>
            </DropdownItem>)
        })
    if (isLoading) {
        return <LoadingIndicator/>
    }

    return <>
        <div className="edit-portfolio-reserve-page__table__column">
            <div style={{display: "flex", marginRight: '2px'}}>
                <div
                    style={{width: "95%"}}
                    data-testid="cvar-quick-slide-container"
                    className={`edit-portfolio-reserve-page__table__column__content ${portfolioRiskRowActive ? "" : "row-inactive"}`}>
                    How risky is this asset allocation?
                    {(portfolioReserveOptions.marketStressTest === "Conditional Value at Risk") &&
                        <div className="edit-portfolio-reserve-page__table__column__subtext">
                            <span>Average of worst 5% of expected returns</span>
                            <Button
                                icon="only"
                                iconName="info_outline"
                                kind="borderless"
                                onClick={onClickHowRiskInfoTip}
                                size="small"
                            />
                        </div>
                    }
                </div>
                <div style={{paddingTop: '16px'}}>
                    <Dropdown data-testid="market-stress-page-action"
                              className={"marginright-md"}
                              panelWidth={270}
                              rounded={true}
                              dropdownKind={"menu"}
                              buttonSize={"small"}
                              buttonIcon={"only"}
                              buttonKind={"borderless"}
                              iconNameOpen={"menu_dots"}
                              iconNameClose={"menu_dots"}
                              alignRight={true}
                              dynamicDropDirection={true}>
                        <DropdownGroup groupName="Market Stress Tests" key={"ls-dropdown-group"} show={true}>
                            <DropdownItem className="reserve-page-action-menu-radio-options" value="" itemText="" onClick={NO_OP}>
                                <RadioGroup
                                    name='monte Carlo Name'
                                    className="reserve-radio-group"
                                    data-testid={"monte-carlo-options"}
                                    layout="vertical"
                                    values={marketStressOptions}
                                    selected={selectedMarketStressOption}
                                    onChange={handleMarketStressOptions}
                                    disabled={false}
                                />
                            </DropdownItem>
                        </DropdownGroup>
                        <DropdownItem className="reserve-page-action-menu-options" value="" itemText="" onClick={NO_OP}
                                      disabled={disableShowImpact} style={{marginTop: '7px'}}>
                            Show Impact on Investable Portfolio
                            <input
                                id="showRiskImpact"
                                name="show-risk-impact"
                                disabled={disableShowImpact}
                                type="checkbox"
                                aria-label="show-risk-impact"
                                key={"show-risk-impact"}
                                style={{marginLeft: '10px'}}
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                    handleReserveOptionDropdown(e);
                                    page(`${currentPage}_Click_Show_Impact_on_Investable_Portfolio_${e.target.checked ? "ON" : "OFF"}`)
                                }}
                                checked={portfolioReserveOptions.showRiskImpact && selectedMarketStressOption === "Conditional Value at Risk"}
                            />
                        </DropdownItem>
                        {(portfolioRiskRowActive && selectedMarketStressOption === "Conditional Value at Risk") &&
                            <MenuDivider
                                className="menu-divider"
                                role="separator"
                                itemText=""
                                value="do_not_use"
                                style={{
                                    padding: "0",
                                    margin: "8px -16px",
                                    borderBottom: "1px solid lightgrey"
                                }}
                            />}
                        {portfolioRiskRowActive &&
                            <DropdownItem value="" itemText="" className="reserve-page-action-menu-options"
                                          onClick={handleHideButton} data-testid="hide-risk-button">
                                Hide this Section
                                <Icon ariaHidden name="visibility_off_outline" style={{marginLeft: '115px'}}/>
                            </DropdownItem>
                        }
                    </Dropdown>
                </div>
            </div>
            {(portfolioReserveOptions.marketStressTest === "Historical Market Events") &&
                <>
                    <div style={{marginTop: '10px', fontWeight: 500}}>Historical Market Stress Event</div>
                    <div style={{marginTop: '10px'}}>
                        <Dropdown
                            className={"add-goal-dropdown-menu dropdown--rounded"}
                            buttonSize="small"
                            buttonIcon="right"
                            buttonKind="secondary"
                            drop="down"
                            dropdownKind="menu"
                            defaultText="SELECT AN EVENT"
                            iconNameOpen="arrow_drop_down"
                            iconNameClose="arrow_drop_down"
                            panelWidth={"auto"}
                            rounded={true}
                            aria-label="Select-Historical-Event"
                        >
                            {stressEventDropdownItems}
                        </Dropdown>
                    </div>
                </>
            }
        </div>
        <div
            className={`edit-portfolio-reserve-page__table__column edit-portfolio-reserve-page__table__second-column edit-portfolio-reserve-page__centered`}>
            <PortfolioRisk
                cvar={editPortfolioReserve.cvar.cvarPortfolioSupports}
                totalInvestableAssetsMinusCash={investableAssetsMinusCashForReserveTarget}
                portfolioRiskRowActive={portfolioRiskRowActive}
                currentPage = {currentPage}
            />
        </div>
        <div
            className={`edit-portfolio-reserve-page__table__column edit-portfolio-reserve-page__table__third-column edit-portfolio-reserve-page__centered`}>
            <PortfolioRisk
                cvar={editPortfolioReserve.cvar.cvarMinimumRisk}
                totalInvestableAssetsMinusCash={investableAssetsMinusCashForMinimumRisk}
                portfolioRiskRowActive={portfolioRiskRowActive}
                currentPage = {currentPage}
            />
        </div>
    </>;
}